import { GTMHelper } from './gtm'
import { NewrelicHelper } from './newrelic'
import { storeError } from '../error/store'

const buildTracker = ({ gtm, newrelic }) => {
  return {
    get $gtm () {
      return gtm
    },
    get $newrelic () {
      return newrelic
    },
    $storeError (err) {
      const msg = err.messageToStore

      if (msg) {
        storeError(msg)
      }
    },
    log (...args) {
      const original = this.$gtm.log(...args)

      const data = {
        name: `${original.eventAction}::${original.eventLabel}`,
        start: (new Date()).getTime(),
        type: 'GTM'
      }

      this.$newrelic.addToTrace(data)
    },
    error (...args) {
      this.$storeError(args[0])

      this.$newrelic.error(...args)
    }
  }
}

const plugin = (Vue, options = {}) => {
  const gtm = new GTMHelper(options)
  const newrelic = new NewrelicHelper(options)
  const tracker = buildTracker({ gtm, newrelic })

  if (options.isTest) {
    Vue.prototype.$tracker = tracker
    return
  }

  Object.defineProperty(Vue.prototype, '$tracker', {
    get: () => tracker
  })
}

export { buildTracker, GTMHelper, plugin }
